import { toAmericanDate } from '../../../helpers';
import {
  CORE, RELATORIOS, gateway,
} from '../../api';

export function findUsuariosComerciais() {
  return gateway.get(`${CORE}/analise-gerencial/usuarios-comerciais`);
}

export function findRendimentoMensalComercial(dataBase,
  idUsuarioComercial,
  apenasAtivos,
  selecionarDosDoisSistemas) {
  const payload = {
    dataReferencia: toAmericanDate(dataBase),
    idUsuarioComercial,
    apenasAtivos,
    selecionarDosDoisSistemas,
  };
  return gateway.post(`${CORE}/analise-gerencial/rendimento-mensal/comercial/pesquisa`, payload);
}

export function imprimirRendimentoMensalComercialExcel(dataBase,
  idUsuarioComercial,
  apenasAtivos,
  selecionarDosDoisSistemas) {
  const payload = {
    dataReferencia: toAmericanDate(dataBase),
    idUsuarioComercial,
    apenasAtivos,
    selecionarDosDoisSistemas,
  };
  return gateway.post(`${RELATORIOS}/analise-gerencial/rendimento-mensal/comercial/download/excel`, payload);
}
export function imprimirRendimentoMensalComercialPdf(dataBase,
  idUsuarioComercial,
  apenasAtivos,
  selecionarDosDoisSistemas) {
  const payload = {
    dataReferencia: toAmericanDate(dataBase),
    idUsuarioComercial,
    apenasAtivos,
    selecionarDosDoisSistemas,
  };
  return gateway.post(`${RELATORIOS}/analise-gerencial/rendimento-mensal/comercial/download/pdf`, payload);
}
